import React from "react";
import { useSelector } from "react-redux";

import { SubmitButton, TextComponent } from "../../../../components";
import styles from "./GuestScreen1.module.css";
import img from "../../../../assets/staticImages/photoimg1.png";
import img1 from "../../../../assets/staticImages/photoimg4.png";
import dummy from "../../../../assets/dummy.jpg";
import dots from "../../../../assets/pfdots.png";
import moment from "moment";

const GuestScreen1 = ({ setCurrentStep }) => {
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);
  return (
    <div className={styles.detailsCont}>
      <TextComponent text={"Congratulations"} textClass={styles.congTxt} />
      <div className={styles.dtlusersImg}>
        <div className={styles.dtluserDetail}>
          <div className={styles.images}>
            <img
              src={
                WeddingWeb?.welcome?.bride?.image
                  ? WeddingWeb?.welcome?.bride?.image
                  : dummy
              }
              className={styles.dtlpfImg}
            />
            <img src={dots} className={styles.dots} />
          </div>
          <TextComponent
            text={WeddingWeb?.welcome?.bride?.name}
            textClass={styles.dtlname}
          />
          {/* <TextComponent text={"Bride"} textClass={styles.role} /> */}
        </div>
        <div className={styles.dtluserDetail}>
          <div className={styles.images}>
            <img
              src={
                WeddingWeb?.welcome?.groom?.image
                  ? WeddingWeb?.welcome?.groom?.image
                  : dummy
              }
              className={styles.dtlpfImg}
            />
            <img src={dots} className={styles.dots} />
          </div>
          <TextComponent
            text={WeddingWeb?.welcome?.groom?.name}
            textClass={styles.dtlname}
          />
          {/* <TextComponent text={"Groom"} textClass={styles.role} /> */}
        </div>
      </div>
      <div className={styles.descriptionDiv}>
        <TextComponent 
          textClass={styles.descriptionTxt}
          text={WeddingWeb?.welcome?.description}
          // textClass={styles.}
        />
      </div>
      <div className={styles.wedDate}>
        <TextComponent text={"Wedding Date"} />
        <TextComponent
          textClass={styles.wedDateTxt}
          text={moment(WeddingWeb?.welcome?.date).format("MMMM DD, yyyy")}
        />
      </div>

      <div className={styles.submitBtn}>
        <SubmitButton
          btnClass={styles.nextBtn2}
          title={"Next"}
          onClick={() => setCurrentStep((prev) => prev + 1)}
        />
      </div>
    </div>
  );
};

export default GuestScreen1;
